/* eslint-disable */

export default {
	common: {
		'1': '일월',
		'2': '이월',
		'3': '삼월',
		'4': '사월',
		'5': '오월',
		'6': '육월',
		'7': '칠월',
		'8': '팔월',
		'9': '구월',
		'10': '십월',
		'11': '십일월',
		'12': '십이월',
		adults: '성인수',
		children: '아동수',
		bookNow: '확인',
		prev: '이전',
		backToHome: '돌아 가기',
		next: '다음',
		detail: '세부 묘사',
		selectDate: '도착 날짜',
		selectHotel: '가지 선택',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '확인',
	},
	pageTitle: {
		brandName: 'Just Sleep 저스트 슬립',
		main: '브랜드',
		news: '최신소식',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을',
		accommodation: '객실',
		facility: '테마',
		restaurant: '다이닝 & 연회 회의',
		location: '시설',
		activity: '관내활동',
	},
	header: {
		main: '브랜드',
		news: '최신소식',
		index: '홈',
		accommodation: '객실',
		facility: '테마',
		restaurant: '다이닝 & 연회 회의',
		location: '시설',
		activity: '관내활동',
		bookNow: '확인',
		taiwan: '대만',
		japan: '일본',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '확인',
	},
	footer: {
		registrationNumber: '관광숙박업 등록번호',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을',
	},
	cookieBar: {
		attention:
			'<p>우리는 귀하의프라이버시를를 존중합니다.</p>\n<p>실크하우스그룹은 좀 더 나은 서비스 및 컨텐츠 개선을 위해 자체 혹은 선택 된 제3자 쿠키를 이용하고있습니다. 본 사이트 사용을 위해서 동의를 부탁드립니다. 실크하우스그룹은모든{{privacyLink}}검토 후, 동의해주시길 권장 드립니다.</p>',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을',
		accept: '동의하기',
	},
	homePage: {
		title: '품격있는 객실 친절한 서비스',
		about: '에 대하여',
		aboutJustsleep: '저스트슬립 은',
		toHotelSite: '세부사항',
		more: '세부사항',
		justNews: '최신소식',
		justComfortTitle: 'Just 편안한 수면',
		justComfortBackTitle: 'Just 편안한 수면',
		justComfortContent:
			'호텔에서는 다양한 베개를 제공해드리고 있으며, 저스트 슬립에 오시는 모든 고객님 한분 한분에게 최고의 수면을 선사해드립니다.',
		justGoTitle: 'Just 즐거운 여행',
		justGoBackTitle: 'Just 즐거운 여행',
		justGoContent:
			'호텔에서는 각 여행지의 관광안내 서비스를 제공해드리고 있습니다. 저스트 슬립의 고객 한분 한분께서 원하시는 관광지와 쇼핑 그리고 교통정보에 대한 안내를 제공해드립니다.\n',
		justEquipTitle: 'Just특별한 아이템',
		justEquipBackTitle: 'Just특별한 아이템',
		justEquipContent:
			'셀카봉, 휴대용 충전 배터리, 여행용 배터리, 손전등 등의 특별 아이템들을 제공해드립니다.（시먼관(西门馆). 및 타이완대학 쭌시엔관(臺大尊賢館) 한정）',
		justBuyTitle: 'Just쇼핑',
		justBuyBackTitle: 'Just쇼핑',
		justBuyContent:
			'타이완의 특별한 기념품 대리 구매 서비스를 제공해 드립니다. 기념품 구매 시간을 절약하시고 더욱 여유로운 여행을 즐기세요.',
		justPackTitle: 'Just포장',
		justPackBackTitle: 'Just포장',
		justPackContent:
			'짐 무게 측정 및 각 사이즈 별 종이박스 판매 서비스를 제공해 드립니다. 무료 전문 포장 서비스와 함께 여유롭게 귀가하세요.',
		justRelax: '편리한 시설',
		justSight: '주차장 안내',
		justGo: '관내활동',
		justExplore: '탐색',
		justService: '친밀한 서비스',
	},
	accommodationPage: {
		rooms: '객실',
		roomFacilityTitle: '어메니티',
		lookupRoomType: '정보 더 보기',
		have: '',
		roomType: '객실 타입',
		am: '아침',
		pm: '오후',
		checkInTime: '체크인 시간',
		checkOutTime: '체크아웃 시간',
		detail: '세부사항',
		bookNow: '확인',
	},
	locationPage: {
		location: '시설',
		trainInfo: '철도 / 고속철도 ',
		busInfo: '고속버스',
		driveInfo: '자가용',
		parkInfo: '주차장',
		hotelInfo: '호텔 셔틀',
		airplaneInfo: '공항에서 호텔까지 오는 법',
	},
	newsHomePage: {
		all: '모두',
		news: '최신소식',
		selectType: '',
		more: '세부사항',
	},
	newsPage: {
		projectTime: '시간',
		projectDetail: '세부 정보',
		note: '비고',
	},
	restaurantPage: {
		restaurantsAndMeetings: '다이닝 & 연회 회의',
		restaurant: '식당',
		meeting: '회의',
	},
	activityPage: {
		activity: '관내활동',
		attractionsNearby: '주차장 안내',
		more: '세부사항',
		lookupSchedule: '세부사항',
		join: '세부사항',
	},
	facilityPage: {
		facility: '테마',
		lookup: '세부사항',
	},
	justFunSection: {
		justFun: '시먼딩 10 곳 저스트 플레이',
	},
	hotelMain: {
		name: '브랜드',
		title: '',
		longName: '브랜드',
		bannerText: '저스트 슬립',
		contactUs: '고객 서비스',
		address: '타이베이시 뤄쓰푸로 4단 83호',
		intro:
			'저스트슬립 은 리젠트 인터내셔널 호텔 그룹(晶華國際酒店集團) 계열의 디자인 호텔 브랜드이며, 「대중적인 가격, 우수한 서비스」를 철학으로 하며, 「우수한 품격，더욱 세심한 정성」의 브랜드 정신으로, 고객님께서 더욱 저렴한 가격으로 5성급 호텔의 최고의 서비스를 누리실 수 있도록 최선을 다하고 있습니다.\n',
	},
	hotelXimen: {
		name: '타이페이 시먼점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 중정구 중화로 1 단 41호 5 층',
		intro:
			'「저스트슬립 타이페이 시먼점」은 번화가의 중심지인 시먼딩(西門町) 상권 근처에 위치해 있어 타이베이 시내의 역사명소들을 보다 편리하고 편안하게 여행하실 수 있으며, 타이베이 젊음의 문화와 함께 현지의 맛있는 음식도 체험하실 수 있습니다.',
	},
	hotelNTU: {
		name: '타이완대학교 점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 뤄쓰푸로 4단 83호',
		intro:
			'「저스트슬립 타이환대학교 점」은 국립 타이완 대학 옆에 위치해 있으며, 캠퍼스의 교육, 실습, 연구, 학술교류, 회의, 세미나 및 행사 참석자들을 위한 편안한 휴식의 장소를 제공해드리고 있습니다. 자유로운 캠퍼스의 이미지를 본 관의 디자인에 융합하여 캠퍼스와의 공존 및 공영의 분위기를 만들어 내고 있습니다.',
	},
	hotelZhongshan: {
		name: '타이베이 중산',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 중산구 중산베이루 1단 135샹 39하오',
		intro:
			"저스트 슬립 타이베이 중산(Just Sleep Taipei Zhongshan)'은 깊은 역사와 현대적인 활기가 어우러진 타이베이 중산구에 위치해 있으며, 지하철(MRT) 중산역과 가까워 뛰어난 교통 접근성을 자랑합니다. 번화한 탸오퉁(條通)과 중산 상권을 여유롭게 산책하며 타이베이의 옛 정취와 최신 트렌드를 동시에 경험할 수 있어, 대만 타이베이를 여행하는 국내외 관광객들에게 완벽한 숙소입니다.",
	},
	hotelKaohsiung: {
		name: '가오슝 종정점',
		title: '',
		contactUs: '고객 서비스',
		address: '가오슝시 영아구 중정1로 134호',
		intro:
			'Just Sleep 가오슝 중정관은 문화와 예술 중심의 융합된 감각적인 디자인으로 넓은 공간을 제공하며, 우먀오(武廟) 야시장과 웨이우잉(衛武營) 예술문화센터, 그리고 지하철역과 인접합니다. 해당 지하철역은 위안극관역(예전 명칭: 기격관역)입니다. 투숙객은 다양한 현지 문화를 체험할 수 있습니다.\n',
	},
	hotelKaohsiungStation: {
		name: '가오슝역 점',
		title: '',
		contactUs: '고객 서비스',
		address: '가오슝시 신싱취 쫑산1루 280하오 ',
		intro:
			'지하철역과 근접한 Just sleep 호텔은 세련되고 모던한 감각의 시각예술 중심적 인테리어로 안락한 숙박을 제공하며, 가오슝 기차역과 유명한 관광명소(세계에서 가장 아름다운 지하철역) 메이리다오역, 류허 야시장과 아주 인접해있으며 다양한 경험을 제공하는 호텔시설은 투숙객의 만족을 보장합니다.',
	},
	hotelHualien: {
		name: '화롄 종정점',
		title: '',
		contactUs: '고객 서비스',
		address: '화롄시 중정로 396호',
		intro:
			'본 호텔은 다양한 현지 음식을 체험할 수 있는 화롄 시내에 자리하고 있습니다. 또한 난빈[東大門] 해안에서 아름다운 바다 풍경을 감상할 수 있으며 문화창작단지에서 창의적 역량을 경험할 수 있습니다.본 호텔은 다양한 현지 음식을 체험할 수 있는 화롄 시내에 자리하고 있습니다. 또한 난빈[東大門] 해안에서 아름다운 바다 풍경을 감상할 수 있으며 문화창작단지에서 창의적 역량을 경험할 수 있습니다.',
	},
	hotelJiaoxi: {
		name: '이란 자오시점',
		title: '이란 온천 호텔',
		contactUs: '고객 서비스',
		address: '이란현 초계향 덕양로 24항8호',
		intro:
			'「저스트슬립 이란 자오시점」은 번화한 자오시(礁溪) 상권 근처에 위치해 있으며, 전 관에서 탄산수소나트륨 온천을 제공하며, 자오시 지역내 디자인 호텔의 새로운 모델로 자리매김 하였습니다.  또한 도보로 우펑치 풍경구(五峰旗風景區), 탕웨이거우 온천공원(湯圍溝溫泉公園)등의 유명 관광명소로 바로 이동하실 수 있습니다.',
	},
	hotelSanchong: {
		name: '타이페이 산총점',
		title: '',
		contactUs: '고객 서비스',
		address: '대만 신베이시 산충구 싼허로 4단 107-1호',
		intro:
			'「저스트슬립 타이페이 산총점」은 MRT 싼허중학교역이 호텔 바로 앞에 위치한 최적의 입지조건을 자랑합니다. 사통팔달의 편리한 교통으로 비즈니스 출장은 물론 레저 여행 시에도 매우 편리합니다. 새롭게 단장한 로프트 스타일의 건축물과 수제 로스팅 커피, 타이완산 잎차를 통해 찾아 주신 모든 여행객에게 편안한 객실에서 만끽하는 여유, 정성으로 모시는 세심한 서비스를 선사합니다.',
	},
	hotelHushan: {
		name: '타이난 후산점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이난시 런더구 원화로 2단 300호',
		intro:
			'「저스트슬립 타이난 후산점」은 스구 문화마을, 치메이 박물관과 인접해 있어 문화 예술적 명소를 편리하게 즐길실 수 있습니다. 고속철도역, 공항, 고속도로 등의 교통 시설과도 가까워 비즈니스 출장 및 가족 휴가를 위한 최고의 선택입니다.',
	},
	hotelOsakaShinsaibashi: {
		name: '오사카 신사이바시는',
		title: '',
		contactUs: '고객 서비스',
		address: '542-0081 오사카시 주오구 미나미시파 2초메 9-15',
		intro:
			'저스트 슬립 오사카 신사이바시는 저스트 슬립 브랜드의 일본 진출 첫 거점입니다. 우리 호텔은 번화가인 산사이바시 비즈니스 지구에 가까이 위치해 있습니다. 비즈니스 지구에 위치한 여러 레스토랑에서 최신 현지 문화를 경험하고 친절한 서비스를 받을 수 있습니다.\n호텔은 신사이바시 역, 혼마치 역, 사카이수지 혼마치 역, 나가호리바시 역 등 주요 지하철역과도 가깝습니다. 이를 통해 다른 관광지로도 쉽게 이동할 수 있기에 저스트 슬립 오카사 신사이바시는 오사카 자유 여행에 있어 최적의 숙소라고 할 수 있습니다.',
		tel: 'Tel : 006-6251-3666',
		fax: 'Fax : +81-06-6251-3889',
	},
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/resources/ko.js